document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector(".inner-container-features");
  const leftButton = document.querySelector(".scroll-button.left");
  const rightButton = document.querySelector(".scroll-button.right");

  // Largeur d'un bloc
  const scrollAmount = container.firstElementChild.offsetWidth + 20; // Largeur du bloc + gap

  // Fonction pour mettre à jour l'état des boutons
  function updateButtonState() {
    if (container.scrollLeft === 0) {
      // Si on est au début, désactiver le bouton gauche
      leftButton.style.opacity = "0.5"; // Visuellement désactivé
      leftButton.style.pointerEvents = "none"; // Désactiver les clics
    } else {
      leftButton.style.opacity = "1";
      leftButton.style.pointerEvents = "auto";
    }

    if (container.scrollLeft + container.offsetWidth >= container.scrollWidth) {
      // Si on est à la fin, désactiver le bouton droit
      rightButton.style.opacity = "0.5"; // Visuellement désactivé
      rightButton.style.pointerEvents = "none"; // Désactiver les clics
    } else {
      rightButton.style.opacity = "1";
      rightButton.style.pointerEvents = "auto";
    }
  }

  // Ajouter des événements sur les boutons
  leftButton.addEventListener("click", () => {
    container.scrollBy({
      left: -scrollAmount, // Défiler d'un bloc vers la gauche
      behavior: "smooth",
    });

    // Mettre à jour l'état des boutons après un court délai pour synchronisation
    setTimeout(updateButtonState, 300);
  });

  rightButton.addEventListener("click", () => {
    container.scrollBy({
      left: scrollAmount, // Défiler d'un bloc vers la droite
      behavior: "smooth",
    });

    // Mettre à jour l'état des boutons après un court délai pour synchronisation
    setTimeout(updateButtonState, 300);
  });

  // Mettre à jour l'état des boutons au chargement
  updateButtonState();

  // Ajouter un événement pour s'assurer que les boutons se mettent à jour si l'utilisateur fait défiler avec le doigt
  container.addEventListener("scroll", updateButtonState);
});
